import { Component, OnInit } from "@angular/core";
import { Auth0AuthorizationService } from "../../auth0/auth0-authorization.service";

@Component({
    selector: "um-sidebar-user",
    templateUrl: "./um-sidebar-user.component.html",
    styleUrls: ["./um-sidebar-user.component.scss"]
})
export class UmSidebarUserComponent implements OnInit {
    _userName: string;
    _userEmail: string;
    _userPicture: string;

    constructor(private _auth0: Auth0AuthorizationService) {}

    ngOnInit(): void {
        this._auth0.getUser().subscribe(user => {
            this._userName = `${user.given_name} ${user.family_name}`;
            this._userEmail = user.email;
            this._userPicture = user.picture;
        });
    }

    _logout(e): void {
        e.stopPropagation();
        e.preventDefault();
        this._auth0.logout();
    }
}
